import { useMemo } from "react";
import { Helmet } from "react-helmet";
import { Link, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ImageAddress from "../../Component/Gallery/ImageAddress.json";

export default function Gallery() {
  const { t } = useTranslation();
  const { lang: langParam } = useParams();
  const location = useLocation();

  // زبان از URL
  const seg = location.pathname.split("/")[1];
  const lang = langParam || (seg === "fa" || seg === "en" ? seg : "en");


  // نرمال‌سازی مسیر تصویرها (../../assets/... -> /assets/...)
  const resolveCover = (src) => {
    if (!src) return "/assets/placeholder.png";
    if (/^https?:\/\//i.test(src) || src.startsWith("/")) return src;
    const cleaned = src.replace(/^(\.\.\/)+assets\//, "/assets/");
    return cleaned.startsWith("/assets/") ? cleaned : `/assets/${cleaned}`;
  };

  // انتخاب آرایه بر اساس زبان + fallback
  const groups = useMemo(() => {
    if (lang === "fa") {
      return ImageAddress.imageGroupsFA || ImageAddress.imageGroups || [];
    }
    return ImageAddress.imageGroupsEN || ImageAddress.imageGroups || [];
  }, [lang]);

  // عنوان کارت
  const getTitle = (item) =>
    lang === "en" ? item.title_en || item.title : item.title;

  return (
    <>
      <Helmet>
        <title>{t("gallery.seo.title")}</title>
        <meta name="description" content={t("gallery.seo.description")} />
        <link
          rel="alternate"
          hrefLang="fa"
          href={`${window.location.origin}/fa/gallery`}
        />
        <link
          rel="alternate"
          hrefLang="en"
          href={`${window.location.origin}/en/gallery`}
        />
      </Helmet>

      <div className="galleryhome" dir={lang === "en" ? "ltr" : "rtl"}>
        <div className="container">
          <h2 className="text-blue1 mb-3 mt-5">{t("gallery.title")}</h2>
          <div className="col-xs-12 col-md-12 noPadding">
            {groups.map((g) => {
              const id = g.imageId || g.id;
              return (
                <div className="col-xs-12 col-md-3" key={id}>
                  <div className="gallerybox">
                    <Link to={`/${lang}/gallery/${g.imageId}`}>
                      <img
                        src={resolveCover(g.imageCover)}
                        className="img-responsive"
                        alt={getTitle(g)}
                        loading="lazy"
                      />
                      <h3>{getTitle(g)}</h3>
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}
